import { render, staticRenderFns } from "./ansi-impact.vue?vue&type=template&id=5af472de&"
import script from "./ansi-impact.vue?vue&type=script&lang=js&"
export * from "./ansi-impact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports